var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle84A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 96 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M68 33.5a2.5 2.5 0 0 1-2.5 2.5h-35a2.5 2.5 0 0 1-2.5-2.5v-7a2.5 2.5 0 0 1 2.5-2.5h35a2.5 2.5 0 0 1 2.5 2.5v7ZM78.5 38a2.5 2.5 0 0 1-2.5-2.5v-11a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M80 38a1 1 0 0 1 1-1h7.5a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.5-1.5H81a1 1 0 1 1 0-2h7.5a3.5 3.5 0 0 1 3.5 3.5v11a3.5 3.5 0 0 1-3.5 3.5H81a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M59.5 43.999a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H62a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M59.5 45.5a1 1 0 0 1 1 1V54a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 1 1 2 0V54a3.5 3.5 0 0 1-3.5 3.5H62a3.5 3.5 0 0 1-3.5-3.5v-7.5a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M40 43.999a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M40 45.5a1 1 0 0 1 1 1V54a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 55 54v-7.5a1 1 0 1 1 2 0V54a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 39 54v-7.5a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20.5 43.999a2.5 2.5 0 0 1 2.5-2.5h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5H23a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M20.5 45.5a1 1 0 0 1 1 1V54a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 1 1 2 0V54a3.5 3.5 0 0 1-3.5 3.5H23a3.5 3.5 0 0 1-3.5-3.5v-7.5a1 1 0 0 1 1-1Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.5 22a2.5 2.5 0 0 1 2.5 2.5v11a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 5 35.5v-11A2.5 2.5 0 0 1 7.5 22h10Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M16 22a1 1 0 0 1-1 1H7.5A1.5 1.5 0 0 0 6 24.5v11A1.5 1.5 0 0 0 7.5 37H15a1 1 0 1 1 0 2H7.5A3.5 3.5 0 0 1 4 35.5v-11A3.5 3.5 0 0 1 7.5 21H15a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M38.666 16.5a2.5 2.5 0 0 1-2.5 2.5H24.5a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 24.5 4h14.166v12.5ZM56.334 16.5a2.5 2.5 0 0 1-2.5 2.5H42.166a2.5 2.5 0 0 1-2.5-2.5V4h16.666v12.5ZM74 16.5a2.5 2.5 0 0 1-2.5 2.5H59.833a2.5 2.5 0 0 1-2.5-2.5V4H71.5A2.5 2.5 0 0 1 74 6.5v10Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M22 15a1 1 0 0 1-1-1V6.5A3.5 3.5 0 0 1 24.5 3h47A3.5 3.5 0 0 1 75 6.5V14a1 1 0 0 1-2 0V6.5A1.5 1.5 0 0 0 71.5 5h-47A1.5 1.5 0 0 0 23 6.5V14a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgRectangle84A.viewBox = '0 0 96 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle84A);
export default ForwardRef;